import {ReactNode, useEffect, useState} from "react";
import {delay} from "../../util/concurrency/Delay";
import {Skeleton} from "@mui/material";


export function SlowContent({loading, children}: {
    loading?: ReactNode,
    children?: ReactNode,
}) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        delay(10).then(() => setVisible(true));
    }, [setVisible]);

    return (
        <>
            {visible
                ? children
                : loading || (
                    <Skeleton variant="rectangular"/>
                )
            }
        </>
    );
}